import { Tag } from "@tine/designsystem-ui-react";

type RecipePreparationTimeProps = {
   workTime?: number | null;
   workTimeRange?: number | null;
};

const RecipePreparationTime = ({ workTime, workTimeRange }: RecipePreparationTimeProps) => {
   if (typeof workTime === "number" && Number.isInteger(workTime)) {
      const text =
         typeof workTimeRange === "number" && Number.isInteger(workTimeRange) && workTimeRange > workTime
            ? `${workTime} - ${workTimeRange} min`
            : `${workTime} min`;
      return <Tag variant="base">{text}</Tag>;
   }
   return null;
};

export default RecipePreparationTime;
